import { render, staticRenderFns } from "./volumeRight.vue?vue&type=template&id=50eb4e72&scoped=true"
import script from "./volumeRight.vue?vue&type=script&lang=js"
export * from "./volumeRight.vue?vue&type=script&lang=js"
import style0 from "./volumeRight.vue?vue&type=style&index=0&id=50eb4e72&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb4e72",
  null
  
)

export default component.exports